import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Router } from '@angular/router';

import { ViewBasePage } from '@shared/pages';
import type { TSetting, THosting } from '@shared/models';

@Component({
    'selector': 'app-campaignHosting',
    'templateUrl': './campaignHosting.page.html',
    'styleUrls': ['./campaignHosting.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ]
})
export class CampaignHostingPage extends ViewBasePage implements OnInit {
    // private dealershipName: string;
    public isDebugMode = false;
    public vm: THosting = {
        enabled: false,
        campaignHostingLink: ''
    };
    public settings: TSetting;
    public submitted = false;

    constructor( injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_SETTINGS_CAMPAIGN_HOSTING);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        try {
            this.isDebugMode = (this.sessionService.isDebugMode());
            await this.uxHelperService.showSpinner();
            const settings: TSetting = await this.settingsService.get();
            this.settings = settings || {} as TSetting;
            this.vm = this.settings.hosting;
            if (!this.vm) {
                this.vm = {
                    enabled: false,
                    campaignHostingLink: ''
                };
            }

            this.onEnabledChange();
            this.initMoreMenu();
            await this.uxHelperService.hideSpinner();
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-campaign-hosting-tour');
    }

    public onEnabledChange() {
        this.vm.enabledStr = this.vm.enabled ?
            'We will automatically build your incentive page for you and host it on our servers.' :
            'You are responsible for building your own incentive page and hosting that page on your own servers. ' +
            'Enter the url of where your incentive page is hosted.';
    }

    public async onSaveClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        try {
            await this.uxHelperService.showSpinner('Saving.');

            this.settings.hosting.enabled = this.vm.enabled;
            if (this.vm.enabled) {
                this.settings.hosting.campaignHostingLink = '';
            } else {
                this.settings.hosting.campaignHostingLink = this.vm.campaignHostingLink;
            }

            await this.settingsService.update(this.settings);
            this.uxHelperService.showToast('Saved.');
            this.router.navigateByUrl('/marketing');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error:', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }
}
